export default __webpack_public_path__ + "static/media/br.5bffd9d4.jpg";